import { useIsMutating } from "@tanstack/react-query";
import { ResourceEnum } from "src/constants/constants.ts";

export const useIsAddingProductToCart = () => {
  const addProductMutationsCount = useIsMutating({
    mutationKey: [ResourceEnum.B2bGateSupplierOrderPosition, "createOne"],
  });

  return addProductMutationsCount > 0;
};
